import React, { useEffect, useMemo, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";

function DecoracionesTienda() {
  const [decoraciones, setDecoraciones] = useState([]);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const cargarDecoraciones = async () => {
      try {
        const snapshot = await getDocs(collection(db, "decoraciones"));

        const lista = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setDecoraciones(lista);
      } catch (error) {
        console.error("Error cargando decoraciones:", error);
      }
    };

    cargarDecoraciones();
  }, []);

  const decoracionesActivas = useMemo(() => {
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);

    return decoraciones.filter((decoracion) => {
      if (!decoracion.activo) return false;

      if (!decoracion.fechaInicio || !decoracion.fechaFin) return false;

      const inicio = new Date(`${decoracion.fechaInicio}T00:00:00`);
      const fin = new Date(`${decoracion.fechaFin}T23:59:59`);

      return hoy >= inicio && hoy <= fin;
    });
  }, [decoraciones]);

  useEffect(() => {
    if (decoracionesActivas.length === 0) return;

    const decoracionConDuracion = decoracionesActivas.find(
      (decoracion) => Number(decoracion.duracionSegundos || 0) > 0,
    );

    if (!decoracionConDuracion) {
      setVisible(true);
      return;
    }

    setVisible(true);

    const timer = setTimeout(
      () => {
        setVisible(false);
      },
      Number(decoracionConDuracion.duracionSegundos) * 1000,
    );

    return () => clearTimeout(timer);
  }, [decoracionesActivas]);

  if (!visible || decoracionesActivas.length === 0) return null;

  const obtenerElementosDecoracion = (decoracion) => {
    if (
      decoracion.elementos &&
      Array.isArray(decoracion.elementos) &&
      decoracion.elementos.length > 0
    ) {
      return decoracion.elementos;
    }

    if (decoracion.elemento) {
      return [decoracion.elemento];
    }

    return ["🎉"];
  };

  const crearElementos = (decoracion) => {
    const cantidad = Math.min(Number(decoracion.cantidad || 1), 30);
    const tamanoPx = Number(decoracion.tamanoPx || 28);
    const movimiento = decoracion.movimiento || "flotar";
    const elementos = obtenerElementosDecoracion(decoracion);

    return Array.from({ length: cantidad }).map((_, index) => {
      const left = (index * 23 + 8) % 92;
      const top = (index * 17 + 10) % 82;
      const delay = (index % 6) * 0.7;
      const duracion = 4 + (index % 5);
      const elemento = elementos[index % elementos.length];

      return (
        <span
          key={`${decoracion.id}-${index}`}
          className={`decoracion-item decoracion-${movimiento}`}
          style={{
            left: `${left}%`,
            top: movimiento === "caer" ? "-10%" : `${top}%`,
            fontSize: `${tamanoPx}px`,
            animationDelay: `${delay}s`,
            animationDuration: `${duracion}s`,
          }}
        >
          {elemento}
        </span>
      );
    });
  };

  return (
    <>
      <style>
        {`
          .decoraciones-tienda {
            position: fixed;
            inset: 0;
            pointer-events: none;
            z-index: 150;
            overflow: hidden;
          }

          .decoracion-item {
            position: absolute;
            display: inline-block;
            opacity: 0.68;
            filter: drop-shadow(0 2px 3px rgba(0,0,0,0.14));
            user-select: none;
          }

          .decoracion-flotar {
            animation-name: decoracionFlotar;
            animation-timing-function: ease-in-out;
            animation-iteration-count: infinite;
          }

          .decoracion-caer {
            animation-name: decoracionCaer;
            animation-timing-function: linear;
            animation-iteration-count: infinite;
          }

          .decoracion-rebotar {
            animation-name: decoracionRebotar;
            animation-timing-function: ease-in-out;
            animation-iteration-count: infinite;
          }

          @keyframes decoracionFlotar {
            0% {
              transform: translateY(0) rotate(0deg);
            }
            50% {
              transform: translateY(-18px) rotate(10deg);
            }
            100% {
              transform: translateY(0) rotate(0deg);
            }
          }

          @keyframes decoracionCaer {
            0% {
              transform: translateY(-20vh) rotate(0deg);
              opacity: 0;
            }
            10% {
              opacity: 0.68;
            }
            100% {
              transform: translateY(120vh) rotate(360deg);
              opacity: 0;
            }
          }

          @keyframes decoracionRebotar {
            0% {
              transform: translateY(0) scale(1);
            }
            40% {
              transform: translateY(-24px) scale(1.08);
            }
            70% {
              transform: translateY(6px) scale(0.96);
            }
            100% {
              transform: translateY(0) scale(1);
            }
          }
        `}
      </style>

      <div className="decoraciones-tienda">
        {decoracionesActivas.flatMap((decoracion) =>
          crearElementos(decoracion),
        )}
      </div>
    </>
  );
}

export default DecoracionesTienda;
